import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/services',
      name: 'services-archives',
      component: () => import(/* webpackChunkName: "archives" */ './views/ServicesArchives.vue'),
      children: [
        {
          path: ':slug',
          name: 'service-details',
          component: () => import(/* webpackChunkName: "detail" */ './views/ServicesDetails.vue'),
        }
      ]
    },
    {
      path: '/step-1',
      name: 'step-1',
      component: () => import(/* webpackChunkName: "step-1" */ './components/form/steps/Step1.vue')
    },
    {
      path: '/step-2',
      name: 'step-2',
      component: () => import(/* webpackChunkName: "step-2" */ './components/form/steps/Step2.vue')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      component: () => import(/* webpackChunkName: "thank-you-page" */ './components/form/steps/ThankYouPage.vue')
    },
    {
      path: '/generic-error',
      name: 'error',
      component: () => import(/* webpackChunkName: "generic-error" */ './components/form/steps/Error.vue')
    }
  ]
})

// add the beforeEach hook
router.beforeEach((to, from, next) => {

  window.scrollTo(0, 0);
  next();
});

export default router;
